/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { Authentication } from "Authentication/Authentication";
import CurrentUserInformation from "Authentication/CurrentUserInformation";
import { getSessionId } from "requests/sessionId";
import { v4 as uuidv4 } from "uuid";
export class BaseClient {
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    options.headers = new Headers({
      "Content-Type": "application/json;",
      Accept: "application/json",
      Authorization: `Bearer ${await Authentication.Instance.GetToken()}`,
      "sekoia.session_id": getSessionId(),
      "sekoia.correlation_id": uuidv4(),
      "sekoia.customer_id":
        CurrentUserInformation.Instance.getUserInformation().customerId,
    });

    return options;
  }

  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REACT_APP_TOGGLE_SERVICE_URL)
      throw new Error(
        "REACT_APP_TOGGLE_SERVICE_URL must be set in environment"
      );

    return process.env.REACT_APP_TOGGLE_SERVICE_URL;
  }
}

export class PingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-toggles-dev.sekoia.one", baseUrl);
    }

    ping(sekoia_customer_id: any): Promise<string> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "sekoia.customer_id": sekoia_customer_id !== undefined && sekoia_customer_id !== null ? "" + sekoia_customer_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class InternalTogglesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-toggles-dev.sekoia.one", baseUrl);
    }

    getAllToggles(sekoia_customer_id: any): Promise<ToggleResponse[]> {
        let url_ = this.baseUrl + "/toggles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "sekoia.customer_id": sekoia_customer_id !== undefined && sekoia_customer_id !== null ? "" + sekoia_customer_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllToggles(_response);
        });
    }

    protected processGetAllToggles(response: Response): Promise<ToggleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ToggleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToggleResponse[]>(<any>null);
    }

    toggleCustomerFeature(toggleCustomerFeatureRequest: ToggleCustomerFeatureRequest, customerId: string, toggleId: string, sekoia_customer_id: any): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalToggles/{customerId}/toggles/{toggleId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (toggleId === undefined || toggleId === null)
            throw new Error("The parameter 'toggleId' must be defined.");
        url_ = url_.replace("{toggleId}", encodeURIComponent("" + toggleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toggleCustomerFeatureRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "sekoia.customer_id": sekoia_customer_id !== undefined && sekoia_customer_id !== null ? "" + sekoia_customer_id : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToggleCustomerFeature(_response);
        });
    }

    protected processToggleCustomerFeature(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class CustomerTogglesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-toggles-dev.sekoia.one", baseUrl);
    }

    getCustomerToggles(customerId: string | null, sekoia_customer_id: any): Promise<CustomerToggleResponse[]> {
        let url_ = this.baseUrl + "/api/CustomerToggles/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "sekoia.customer_id": sekoia_customer_id !== undefined && sekoia_customer_id !== null ? "" + sekoia_customer_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerToggles(_response);
        });
    }

    protected processGetCustomerToggles(response: Response): Promise<CustomerToggleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerToggleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerToggleResponse[]>(<any>null);
    }

    getCustomerTogglesInNamespace(customerId: string | null, namespace: string | null, sekoia_customer_id: any): Promise<CustomerToggleResponse[]> {
        let url_ = this.baseUrl + "/api/CustomerToggles/{customerId}/namespace/{namespace}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "sekoia.customer_id": sekoia_customer_id !== undefined && sekoia_customer_id !== null ? "" + sekoia_customer_id : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerTogglesInNamespace(_response);
        });
    }

    protected processGetCustomerTogglesInNamespace(response: Response): Promise<CustomerToggleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerToggleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerToggleResponse[]>(<any>null);
    }
}

export class ToggleResponse implements IToggleResponse {
    name!: string;
    namespace!: string;
    friendlyName?: string | null;
    toggleId!: string;

    constructor(data?: IToggleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.namespace = _data["namespace"] !== undefined ? _data["namespace"] : <any>null;
            this.friendlyName = _data["friendlyName"] !== undefined ? _data["friendlyName"] : <any>null;
            this.toggleId = _data["toggleId"] !== undefined ? _data["toggleId"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["namespace"] = this.namespace !== undefined ? this.namespace : <any>null;
        data["friendlyName"] = this.friendlyName !== undefined ? this.friendlyName : <any>null;
        data["toggleId"] = this.toggleId !== undefined ? this.toggleId : <any>null;
        return data; 
    }
}

export interface IToggleResponse {
    name: string;
    namespace: string;
    friendlyName?: string | null;
    toggleId: string;
}

export class ToggleCustomerFeatureRequest implements IToggleCustomerFeatureRequest {
    customerId!: string;
    toggleId!: string;
    isEnabled!: boolean;
    organisationToggles!: ToggleOrganisationFeatureRequest[];

    constructor(data?: IToggleCustomerFeatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationToggles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.toggleId = _data["toggleId"] !== undefined ? _data["toggleId"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
            if (Array.isArray(_data["organisationToggles"])) {
                this.organisationToggles = [] as any;
                for (let item of _data["organisationToggles"])
                    this.organisationToggles!.push(ToggleOrganisationFeatureRequest.fromJS(item));
            }
            else {
                this.organisationToggles = <any>null;
            }
        }
    }

    static fromJS(data: any): ToggleCustomerFeatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleCustomerFeatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["toggleId"] = this.toggleId !== undefined ? this.toggleId : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        if (Array.isArray(this.organisationToggles)) {
            data["organisationToggles"] = [];
            for (let item of this.organisationToggles)
                data["organisationToggles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IToggleCustomerFeatureRequest {
    customerId: string;
    toggleId: string;
    isEnabled: boolean;
    organisationToggles: ToggleOrganisationFeatureRequest[];
}

export class ToggleOrganisationFeatureRequest implements IToggleOrganisationFeatureRequest {
    customerId!: string;
    organisationId!: string;
    isEnabled!: boolean;

    constructor(data?: IToggleOrganisationFeatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleOrganisationFeatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleOrganisationFeatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        return data; 
    }
}

export interface IToggleOrganisationFeatureRequest {
    customerId: string;
    organisationId: string;
    isEnabled: boolean;
}

export class CustomerToggleResponse implements ICustomerToggleResponse {
    featureEnabledForOrganisations!: FeatureEnabledForOrganisation[];
    toggleId!: string;
    name!: string;
    namespace!: string;
    isEnabledForCustomer!: boolean;
    customerId!: string;

    constructor(data?: ICustomerToggleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureEnabledForOrganisations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureEnabledForOrganisations"])) {
                this.featureEnabledForOrganisations = [] as any;
                for (let item of _data["featureEnabledForOrganisations"])
                    this.featureEnabledForOrganisations!.push(FeatureEnabledForOrganisation.fromJS(item));
            }
            else {
                this.featureEnabledForOrganisations = <any>null;
            }
            this.toggleId = _data["toggleId"] !== undefined ? _data["toggleId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.namespace = _data["namespace"] !== undefined ? _data["namespace"] : <any>null;
            this.isEnabledForCustomer = _data["isEnabledForCustomer"] !== undefined ? _data["isEnabledForCustomer"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerToggleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerToggleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureEnabledForOrganisations)) {
            data["featureEnabledForOrganisations"] = [];
            for (let item of this.featureEnabledForOrganisations)
                data["featureEnabledForOrganisations"].push(item.toJSON());
        }
        data["toggleId"] = this.toggleId !== undefined ? this.toggleId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["namespace"] = this.namespace !== undefined ? this.namespace : <any>null;
        data["isEnabledForCustomer"] = this.isEnabledForCustomer !== undefined ? this.isEnabledForCustomer : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        return data; 
    }
}

export interface ICustomerToggleResponse {
    featureEnabledForOrganisations: FeatureEnabledForOrganisation[];
    toggleId: string;
    name: string;
    namespace: string;
    isEnabledForCustomer: boolean;
    customerId: string;
}

export class FeatureEnabledForOrganisation implements IFeatureEnabledForOrganisation {
    isEnabled!: boolean;
    organisationId!: string;

    constructor(data?: IFeatureEnabledForOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
        }
    }

    static fromJS(data: any): FeatureEnabledForOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureEnabledForOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        return data; 
    }
}

export interface IFeatureEnabledForOrganisation {
    isEnabled: boolean;
    organisationId: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}